import React from "react"
import styled from "styled-components"
import { Styles } from "../../../config"
import { Flex } from "../../../container-components"

export const ChatContainer = styled.div`
	background: ${(props) => (props.person === "bot" ? "rgb(245, 245, 245)" : Styles.Color.secondary)};
	color: ${(props) => (props.person === "bot" ? Styles.Color.primary : Styles.Color.white)};
	padding: 17px 20px;

	max-width: 180px;
	border-radius: 5px;
`

export const ResponseContainer = styled.button`
	background: rgb(245, 245, 245);
	color: ${Styles.Color.primary};
	padding: 12px 15px;
	margin: 0 0 10px;
	max-width: 250px;
	border-radius: 5px;

	&:hover {
		background: ${Styles.Color.secondary};
		cursor: pointer;
	}
	&:hover > span {
		color: ${Styles.Color.white};
	}
`

export const MessageButton = styled.button`
	width: 60px;
	height: 60px;
	box-shadow: rgb(0 0 0 / 6%) 0px 1px 6px 0px, rgb(0 0 0 / 16%) 0px 2px 32px 0px;
	border-radius: 999px;
	background: ${Styles.Color.secondary};
	cursor: pointer;
	position: fixed;
	bottom: 25px;
	right: 25px;
	z-index: 1000;

	& > i {
		color: ${Styles.Color.white};
		font-weight: 20px;
	}

	@media (max-width: 449px) {
		width: 50px;
		height: 50px;
		bottom: 15px;
		right: 15px;
	}
`

export const MessageContainer = styled.div`
	display: flex;
	z-index: 1000;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	width: 100%;
	height: 100%;
	position: relative;

	border-radius: 5px;
	${(props) =>
		!props.isInline &&
		` 
  max-width: 325px;
  height: 640px;
  position: fixed;
  bottom: 100px;
  right: 25px;
  `}

	overflow-y: hidden;
	background: ${Styles.Color.white};
	box-shadow: 0 24px 38px 3px rgb(127 194 255 / 19%), 0 9px 46px 8px rgb(127 194 255 / 27%),
		0 11px 15px -7px rgb(127 194 255 / 2%);

	@media (max-width: 800px) {
		border-radius: 0px;
		bottom: 0;
		right: 0;
		max-width: 100%;
		height: 100%;
	}
`

export const Transformer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	transition: transform 100ms ease-in-out;
	opacity: ${(props) => (props.isTransforming?.isHidden ? "0" : "1")};
	transform: ${(props) =>
		props.isTransforming?.transforming ? `translateX(${props.isTransforming?.percent})` : "translateX(0%)"};
	align-items: center;
	overflow-y: ${(props) => (props.chatbotConfig?.type === "calendly" ? "hidden" : "auto")};
	height: 100%;
`

export const BotContainer = styled.div`
	background: ${Styles.Color.white};
	width: 90%;
	min-height: 130px;
	border-radius: 5px;
	box-shadow: 0 24px 38px 3px rgb(127 194 255 / 19%), 0 9px 46px 8px rgb(127 194 255 / 27%),
		0 11px 15px -7px rgb(127 194 255 / 2%);
	margin: ${(props) => props.margin};
	z-index: 1;

	& > div {
		display: flex;
		align-items: flex-start;
		flex-direction: column;
		padding: 26px 24px 16px;
	}
`

export const BotContainerButton = styled.button`
	height: 69px;
	width: 100%;
	padding: 5px;
	display: flex;
	align-items: center;
	max-width: 325px;
	background: ${Styles.Color.white};
	overflow: hidden;
	justify-content: flex-start;
	&:hover {
		cursor: pointer;
		background: rgba(0, 0, 0, 0.16);
	}
`

export const BotImage = styled.img`
	width: 30px;
	border-radius: 999px;
	height: 30px;
	object-fit: cover;
	margin: 0 10px 0 0;
`

export const BlockButton = styled.button`
	width: 50px;
	height: 50px;
	background: transparent;
	border-radius: 5px;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1001;
	margin: ${(props) => props.margin || "0"};

	&:hover {
		background: rgba(0, 0, 0, 0.5);
		cursor: pointer;
	}
`

export const RoundedButton = styled.button`
	width: 180px;
	height: 40px;
	border-radius: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 7px 0;
	color: ${Styles.Color.primary};
	background: ${Styles.Color.white};
	border: 1px solid;
	cursor: pointer;

	&:hover {
		color: ${Styles.Color.secondary};
	}
	&:hover > * {
		color: ${Styles.Color.secondary};
	}
`

export const ContactInput = styled.input`
	padding-top: 20px;
	width: 100%;
	border-bottom: 1px solid rgb(225, 225, 225);
	padding-bottom: 16px;
	width: 90%;
	outline: none;
	border-left: none;
	border-right: none;
	border-top: none;
`

export const ContactSubmit = styled.button`
	width: 40px;
	height: 40px;
	background: ${Styles.Color.secondary};
	cursor: pointer;
	border-radius: 5px;

	& > i {
		color: ${Styles.Color.white};
		font-size: 20px;
	}

	&:disabled {
		background: ${Styles.Color.gray};
		cursor: not-allowed;
	}
`

export const ContactInputSubmit = (props) => {
	return (
		<Flex nowrap>
			<ContactInput {...props}></ContactInput>
			<ContactSubmit disabled={props.isDisabled} type="submit">
				<i className="material-icons">send</i>
			</ContactSubmit>
		</Flex>
	)
}

export const ContactTextArea = styled.textarea`
	padding-top: 20px;
	line-height: 1.33;
	overflow-y: auto;
	flex: 1 1 0%;
	width: 90%;
	margin: 0px 0px 50px;
	resize: none;
	min-height: 395px;
	border: none;
	outline: none;
	white-space: break-spaces;
`

export const SendButton = styled.button`
	color: ${Styles.Color.primary};
	border: none;
	background: transparent;
	margin: 0 5px 0 0;
	cursor: pointer;

	&:disabled {
		color: ${Styles.Color.disabled};
		cursor: not-allowed;
	}

	& > i {
		font-size: 18x;
	}
`
